import { useQuery } from "@tanstack/react-query";

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {string} deps.authority
 * @param {Record<string, string>} deps.requestHeaders
 * @param {boolean} deps.enabled
 */
export function useObservabilityContracts({
  callApiWithWorker,
  authority,
  requestHeaders,
  enabled = true,
}) {
  const requestHeadersKey = JSON.stringify(requestHeaders ?? {});

  return useQuery({
    queryKey: [
      "observability",
      "contracts",
      authority ?? "",
      requestHeadersKey,
    ],
    enabled: Boolean(enabled),
    keepPreviousData: true,
    queryFn: async () => {
      const resp = await callApiWithWorker("api/observability/contracts", {
        method: "GET",
        headers: {
          ...(authority !== undefined ? { authority: authority ?? "" } : {}),
          ...(requestHeaders ?? {}),
        },
      });
      return resp?.result ?? [];
    },
  });
}
